import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appNumeric]'
})
export class NumericDirective {

  constructor() { }

  @HostListener('keypress', ['$event'])
  onKeyPress(event: KeyboardEvent): boolean {
    const key = parseInt(event.key, 10);
    // Only numbers 0-9
    if (!isNaN(key) && key >= 0 && key <= 9) {
      return true;
    }
    event.preventDefault();
    return false;
  }
}
